var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-inventory-items u-flex-center"},_vm._l((_vm.items),function(item){return _c('ez-entity-info',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      html: true,
      placement: 'start',
      content: _vm.tooltipContent(item),
      classes: ['tooltip-general'],
    }),expression:"{\n      html: true,\n      placement: 'start',\n      content: tooltipContent(item),\n      classes: ['tooltip-general'],\n    }"}],key:item.id,staticClass:"product-inventory-items__item",attrs:{"imgUrl":item.product.image,"imgWidth":"2rem","imgHeight":"2rem","imgBorderRadius":"3px"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }